import { AnchoredPluginsHandler } from "./AnchoredPluginsHandler";
import { CellSelection } from "./selection/CellSelection";

import { LABEL_PROPERTIES, LABEL_DRAGPOINT } from "../components/cell/grid-cell.config";
import { createNestedCircle, notificationBellShape } from "../components/components.utils";
import { DiagramEventEmitter } from "../../../diagram/modules/DiagramEventEmitter";
import { DIAGRAM_EMIT_EVENTS } from "../../../diagram/modules/DiagramEvents";
import { ConnectingLineHandler } from "./ConnectingLineHandler";
import { GridSizedViewUtils } from "../utils/GridSizeViewUtils";
import { CellRetrievalUtils } from "../utils/CellRetrievalUtils";
import { DiagramUtils } from "../../../diagram/diagram-assets/DiagramUtils";
import { roundRect } from "../../../utils/utils";
import { getInstanceIDFromCanvasInstance } from "../../../diagram/diagram-assets/diagram-positioning-state";

export class LabelHandler {
    labelsList = [];

    connectorsList = [];

    labelProperties = LABEL_PROPERTIES;

    selectedLabel = null;

    selectedIndexLabel = null;

    selectedIndexConnector = null;

    selectedLabelConnect = null;

    camera;

    eventEmitter;

    connectingLineHandler;

    labelCell; // cell instance unde label-ul se afla la mouse down

    cellRetrieval = new CellRetrievalUtils();

    cellSelection;

    selectedCellPlugin = null;

    generatedGrid = [];

    constructor(camera, instanceUuid, canvasCtx, generatedGrid) {
        this.camera = camera;
        this.instanceUuid = instanceUuid;
        this.eventEmitter = new DiagramEventEmitter(this.instanceUuid);
        this.connectingLineHandler = new ConnectingLineHandler(this.instanceUuid);
        this.cellSelection = new CellSelection(getInstanceIDFromCanvasInstance(canvasCtx));
        this.generatedGrid = generatedGrid;
        this.anchoredPluginsHandler = new AnchoredPluginsHandler(getInstanceIDFromCanvasInstance(canvasCtx));
    }

    mouseMoveLabel(mousePos, scope, grid, connectingLineHandler) {
        let minX; let maxX; let minY; let
            maxY;
        if (this.selectedLabel) {
            const widthLabel = this.getLabelWidth(scope.camera.ctx, this.labelsList[this.selectedIndexLabel].label);
            const dx = (widthLabel.labelWidth.width / 2) + (this.labelProperties.paddingLabelX * 2) + (this.labelProperties.dragPointLabelRadius * 2);
            const dy = widthLabel.secondLine ? parseInt(this.labelProperties.fontLabel) + (parseInt(this.labelProperties.paddingLabelTopBottom) * 3) : 0;

            minX = (this.selectedLabel.cellStartPoint.x === scope.config.viewPadding ? this.selectedLabel.cellStartPoint.x : this.selectedLabel.cellStartPoint.x - scope.config.cellWidth) + dx;
            maxX = this.selectedLabel.cellStartPoint.x + (scope.config.cellWidth * 2) - dx;
            minY = this.selectedLabel.cellStartPoint.y === scope.config.viewPadding ? this.selectedLabel.cellStartPoint.y + dy : this.selectedLabel.cellStartPoint.y - scope.config.cellHeight + dy;
            maxY = this.selectedLabel.cellStartPoint.y + (scope.config.cellHeight * 2) - parseInt(this.labelProperties.fontLabel) - dy;

            if (minX < mousePos.x && mousePos.x < maxX && minY < mousePos.y && mousePos.y < maxY) {
                this.clearTextLabel(mousePos, scope, "pluginLabel");
            }
        } else if (this.selectedLabelConnect) {
            const widthLabel = this.getLabelWidth(scope.camera.ctx, this.connectorsList[this.selectedIndexConnector].label.value);
            const dx = (widthLabel.labelWidth.width / 2) + (this.labelProperties.paddingLabelX * 2) + (this.labelProperties.dragPointLabelRadius * 2);
            const dy = widthLabel.secondLine ? parseInt(this.labelProperties.fontLabel) + (parseInt(this.labelProperties.paddingLabelTopBottom) * 3) : 0;

            minX = (this.labelCell.layout.x === scope.config.viewPadding ? this.labelCell.layout.x : this.labelCell.layout.x - scope.config.cellWidth) + dx;
            maxX = this.labelCell.layout.x + scope.config.cellWidth * 2 - dx;
            minY = this.labelCell.layout.y === scope.config.viewPadding ? this.labelCell.layout.y + dy : this.labelCell.layout.y - scope.config.cellHeight + dy;
            maxY = this.labelCell.layout.y + scope.config.cellHeight * 2 - dy;

            if (minX < mousePos.x && mousePos.x < maxX && minY < mousePos.y && mousePos.y < maxY) {
                this.clearTextLabel(mousePos, scope);
            }
        }
    }

    clearTextLabel(mousePos, scope, type) {
        if (type === "pluginLabel") {
            this.labelsList[this.selectedIndexLabel].labelPosition.x = mousePos.x;
            this.labelsList[this.selectedIndexLabel].labelPosition.y = mousePos.y;
        } else {
            this.connectorsList[this.selectedIndexConnector].label.x = mousePos.x;
            this.connectorsList[this.selectedIndexConnector].label.y = mousePos.y;
        }

        scope.camera.draw();
    }

    redrawLabels(payload, ctx) {
        let minX; let maxX; let minY; let
            maxY;
        minX = payload.x - payload.width;
        maxX = payload.x + payload.width * 2;
        minY = payload.y - payload.height;
        maxY = payload.y + payload.height * 2;

        this.getSelectedCellInstance();

        for (let i = 0; i < this.labelsList.length; i++) {
            if (minX < this.labelsList[i].labelPosition.x && this.labelsList[i].labelPosition.x < maxX
                && minY < this.labelsList[i].labelPosition.y && this.labelsList[i].labelPosition.y < maxY) {
                ctx.textBaseline = "top";
                ctx.textAlign = "center";
                ctx.font = `${this.labelProperties.fontLabel}px`;
                // ctx.fillStyle = this.state ? "#256BDE" : "#444444";

                let widthOfPluginText = null; const scope = this;
                const textObject = this.getLabelWidth(ctx, this.labelsList[i].label);

                if (textObject.secondLine) {
                    widthOfPluginText = textObject.labelWidth;
                    this.createBackgroundLabelRectangle(this.labelsList[i].labelPosition.x, this.labelsList[i].labelPosition.y, widthOfPluginText.width, ctx, null, "HAS_SECOND_LINE");
                    ctx.fillStyle = scope.labelsList[i].disabled ? this.labelProperties.disabledColorLabel : this.selectedCellPlugin && this.selectedCellPlugin.uuid === this.labelsList[i].pluginUUID ? "#256BDE" : "#444444";
                    ctx.fillText(textObject.firstLine, this.labelsList[i].labelPosition.x,
                        this.labelsList[i].labelPosition.y - parseInt(this.labelProperties.fontLabel) - parseInt(this.labelProperties.paddingLabelTopBottom) - (parseInt(this.labelProperties.paddingLabelTopBottom) / 2));
                    ctx.fillText(textObject.secondLine, this.labelsList[i].labelPosition.x,
                        this.labelsList[i].labelPosition.y - parseInt(this.labelProperties.paddingLabelTopBottom) / 2);
                } else {
                    widthOfPluginText = textObject.labelWidth;
                    this.createBackgroundLabelRectangle(this.labelsList[i].labelPosition.x, this.labelsList[i].labelPosition.y, widthOfPluginText.width, ctx);
                    ctx.fillStyle = scope.labelsList[i].disabled ? this.labelProperties.disabledColorLabel : this.selectedCellPlugin && this.selectedCellPlugin.uuid === this.labelsList[i].pluginUUID ? "#256BDE" : "#444444";
                    ctx.fillText(textObject.firstLine, scope.labelsList[i].labelPosition.x, scope.labelsList[i].labelPosition.y, payload.width);
                }

                let styleBackground = null;
                if (this.selectedCellPlugin && this.selectedCellPlugin.uuid === this.labelsList[i].pluginUUID) {
                    styleBackground = {
                        resetlineWidth: this.labelsList[i].disabled,
                        lineWidth: this.labelsList[i].disabled ? 0 : this.labelProperties.lineWidthBackground,
                        strokeStyle: this.labelProperties.dragPointSelectedStrokeTask,
                        fillStyle: scope.labelsList[i].disabled ? this.labelProperties.disabledColorLabel : this.labelProperties.taskDragPointColor
                    };
                }

                createNestedCircle(this.labelsList[i].labelPosition.x - (widthOfPluginText.width / 2) - this.labelProperties.paddingLabelX - this.labelProperties.dragPointLabelRadius,
                    this.labelsList[i].labelPosition.y + (textObject.secondLine ? -(this.labelProperties.dragPointLabelRadius + this.labelProperties.fontLabel / 2) : parseInt(this.labelProperties.fontLabel) / 2),
                    [this.labelProperties.dragPointLabelRadius], scope.labelsList[i].disabled ? { fillStyleFirst: this.labelProperties.disabledColorLabel } : LABEL_DRAGPOINT, ctx, styleBackground);
                this.anchoredPluginsHandler.cellDrawing(this.labelsList[i].uuidCell);
            }
        }

        for (let i = 0; i < this.connectorsList.length; i++) {
            const checkIfDrawLabel = this.connectorsList[i].instance && this.connectorsList[i].instance.state.readonlyDisabled && (this.connectorsList[i].instance.state.disabled || this.connectorsList[i].disabled);
            if (minX < this.connectorsList[i].label.x && this.connectorsList[i].label.x < maxX
                && minY < this.connectorsList[i].label.y && this.connectorsList[i].label.y < maxY && !checkIfDrawLabel) {
                ctx.textBaseline = "top";
                ctx.textAlign = "center";
                ctx.font = `${this.labelProperties.fontLabel}px`;
                ctx.fillStyle = this.state ? "#256BDE" : "#444444";

                let widthOfPluginText = null; const scope = this; const fillStyleConn = "#444444";
                const textObject = this.getLabelWidth(ctx, this.connectorsList[i].label.value);
                const reduceHeight = parseInt(this.labelProperties.fontLabel) + this.labelProperties.paddingLabelY + 3; // this.midPointRadius = 3

                if (textObject.secondLine) {
                    widthOfPluginText = textObject.labelWidth;
                    this.createBackgroundLabelRectangle(this.connectorsList[i].label.x, this.connectorsList[i].label.y, widthOfPluginText.width, ctx, "LABELCONN", "HAS_SECOND_LINE");
                    ctx.fillStyle = fillStyleConn;
                    ctx.fillText(textObject.firstLine, scope.connectorsList[i].label.x,
                        scope.connectorsList[i].label.y - parseInt(scope.labelProperties.fontLabel) - parseInt(scope.labelProperties.paddingLabelTopBottom) - (parseInt(scope.labelProperties.paddingLabelTopBottom) / 2));
                    ctx.fillText(textObject.secondLine, scope.connectorsList[i].label.x,
                        scope.connectorsList[i].label.y - parseInt(scope.labelProperties.paddingLabelTopBottom) / 2);
                } else {
                    widthOfPluginText = textObject.labelWidth;
                    this.createBackgroundLabelRectangle(this.connectorsList[i].label.x, this.connectorsList[i].label.y, widthOfPluginText.width, ctx, "LABELCONN");
                    ctx.fillStyle = fillStyleConn;
                    ctx.fillText(textObject.firstLine, scope.connectorsList[i].label.x, scope.connectorsList[i].label.y);
                }
                // if (this.data && this.data.notification) {
                //     notificationBellShape(this.midPoint.x - (widthOfPluginText.width / 2) - this.labelProperties.paddingLabelX - this.notificationBellWidth / 2,
                //                     this.midPoint.y - (textObject["secondLine"] ? reduceHeight : reduceHeight * 2 / 3), this.state ? "#256BDE" : "#444444",
                //                     ctx);
                // }

                createNestedCircle(this.connectorsList[i].label.x - (widthOfPluginText.width / 2) - this.labelProperties.paddingLabelX - this.labelProperties.dragPointLabelRadius,
                    this.connectorsList[i].label.y + (textObject.secondLine ? -(this.labelProperties.dragPointLabelRadius + this.labelProperties.fontLabel / 2) : parseInt(this.labelProperties.fontLabel) / 2),
                    [this.labelProperties.dragPointLabelRadius], LABEL_DRAGPOINT, ctx, { fillStyle: this.labelProperties.dragPointFillConnector });

                const mesureLabel = this.getLabelWidth(ctx, this.connectorsList[i].label.value);
                this.anchoredPluginsHandler.checkForAnchoredTouch(this.connectorsList[i], mesureLabel, this.labelProperties);
            }
        }
    }

    addNewLabel(cell, ctx) {
        let newLabel;
        const widthLabel = ctx.measureText(cell.content.instance.label); let labelCellPosition; let
            dragPoint;

        labelCellPosition = {
            x: cell.layout.x + cell.layout.width / 2 + this.labelProperties.dragPointLabelRadius + this.labelProperties.paddingLabelX / 2,
            y: cell.layout.y + this.labelProperties.paddingLabelY
        };

        dragPoint = {
            x: labelCellPosition.x - (widthLabel.width / 2) - this.labelProperties.paddingLabelX
                - (this.labelProperties.dragPointLabelRadius * 2) - this.labelProperties.dragPointLabelRadius,
            y: labelCellPosition.y - this.labelProperties.paddingLabelY
        };

        newLabel = {
            label: cell.content.instance.content.name,
            labelPosition: labelCellPosition,
            labelDragPoint: dragPoint,
            cellStartPoint: { x: cell.layout.x, y: cell.layout.y },
            uuidCell: cell.uuid,
            uuid: new DiagramUtils().generateUUID(),
            pluginUUID: cell.content.instance.content.uuid,
            pluginID: cell.contentData.id,
            labelMoved: false,
            cellInstance: cell
        };
        this.labelsList.push(newLabel);
        this.eventEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.PLUGIN_LABEL_CREATED,
            {
                LABEL_UUID: newLabel.uuid, LABEL_VALUE: newLabel.label, PLUGIN_UUID: newLabel.pluginUUID, PLUGIN_ID: newLabel.pluginID
            }, false, false);
    }

    setAdditionalOptions(data) {
        if (data.pluginUUID) {
            this.labelsList.forEach(element => {
                if (element.pluginUUID === data.pluginUUID) {
                    element.additionalOptions = data.additionalOptions;
                }
            });
        }
    }

    getAdditionalOptions(pluginUUID) {
        const data = this.labelsList.find(element => element.pluginUUID === pluginUUID);
        return data && data.additionalOptions ? data.additionalOptions : null;
    }

    checkIfLabelSelected(mousePos, grid) {
        const gridSizeUtils = new GridSizedViewUtils();
        const newCell = gridSizeUtils.getPermanentGridCellPos(mousePos, grid); const list = this.labelsList;
        let insideLabel = false;

        for (let i = 0; i < list.length; i++) {
            let labelMinX; let labelMaxX; let labelMinY; let labelMaxY; let widthLabel; let addWidth; let
                addOnHeight;
            widthLabel = this.getLabelWidth(this.camera.ctx, list[i].label);
            addWidth = (widthLabel.labelWidth.width / 2) + (this.labelProperties.paddingLabelX * 2) + (this.labelProperties.dragPointLabelRadius * 2);
            addOnHeight = widthLabel.secondLine ? parseInt(this.labelProperties.fontLabel) + (parseInt(this.labelProperties.paddingLabelTopBottom) * 3) : parseInt(this.labelProperties.fontLabel) / 2 + parseInt(this.labelProperties.paddingLabelTopBottom) * 2;

            labelMinX = list[i].labelPosition.x - addWidth;
            labelMaxX = list[i].labelPosition.x + addWidth;
            labelMinY = list[i].labelPosition.y - addOnHeight;
            labelMaxY = list[i].labelPosition.y + addOnHeight;

            if (labelMinX < mousePos.x && mousePos.x < labelMaxX
                && labelMinY < mousePos.y && mousePos.y < labelMaxY) {
                this.selectedLabel = list[i];
                this.selectedIndexLabel = i;

                this.selectedLabel.labelMoved = true;
                insideLabel = true;
                break;
            }
        }
        return insideLabel;
    }

    checkIfLabelConnector(mousePos) {
        let insideLabelCon = false; const
            list = this.connectorsList;

        for (let i = 0; i < list.length; i++) {
            let labelMinX; let labelMaxX; let labelMinY; let labelMaxY; let widthLabel; let addWidth; let
                addOnHeight;
            widthLabel = this.getLabelWidth(this.camera.ctx, list[i].label.value);
            addWidth = (widthLabel.labelWidth.width / 2) + (this.labelProperties.paddingLabelX * 3) + (this.labelProperties.dragPointLabelRadius * 2);
            addOnHeight = widthLabel.secondLine ? parseInt(this.labelProperties.fontLabel) + (parseInt(this.labelProperties.paddingLabelTopBottom) * 3) : parseInt(this.labelProperties.fontLabel) / 2 + parseInt(this.labelProperties.paddingLabelTopBottom) * 2;

            labelMinX = list[i].label.x - addWidth;
            labelMaxX = list[i].label.x + addWidth;
            labelMinY = list[i].label.y - addOnHeight;
            labelMaxY = list[i].label.y + addOnHeight;

            if (labelMinX < mousePos.x && mousePos.x < labelMaxX
                && labelMinY < mousePos.y && mousePos.y < labelMaxY) {
                this.selectedLabelConnect = list[i];
                this.selectedIndexConnector = i;
                insideLabelCon = true;
                break;
            }
        }
        return insideLabelCon;
    }

    setLabelNewPosition(mousePos, camera) {
        if (this.selectedLabel) {
            const list = this.labelsList;
            for (let i = 0; i < list.length; i++) {
                if (this.selectedLabel.uuid === list[i].uuid) {
                    this.calculateMinMaxCoordonate(list[i], mousePos, "labelPosition");
                    this.selectedLabel = null;
                    this.selectedIndexLabel = null;
                    break;
                }
            }
            camera.draw();
        } else if (this.selectedLabelConnect) {
            for (let i = 0; i < this.connectorsList.length; i++) {
                if (this.selectedLabelConnect.uuid === this.connectorsList[i].uuid) {
                    this.calculateMinMaxCoordonate(this.connectorsList[i], mousePos, "label");
                    this.selectedLabelConnect = null;
                    this.selectedIndexConnector = null;
                    break;
                }
            }
        }
    }

    calculateMinMaxCoordonate(item, coordonate, property) {
        let widthLabel; let labelMinX; let labelMaxX; let labelMinY; let labelMaxY; let dragPointDiameter;
        let dxMin; let dxMax; let dyMin; let
            dyMax;

        dragPointDiameter = this.labelProperties.dragPointLabelRadius * 2;
        widthLabel = this.camera.ctx.measureText(typeof item.label === "object" ? item.label.value : item.label);
        dxMin = parseInt(widthLabel.width / 2 + this.labelProperties.paddingLabelX + dragPointDiameter);
        dxMax = parseInt(widthLabel.width / 2);
        dyMin = parseInt(this.labelProperties.fontLabel) / 2;
        dyMax = parseInt(this.labelProperties.fontLabel) / 2 + this.labelProperties.paddingLabelY / 2;

        labelMinX = item[property].x - dxMin;
        labelMaxX = item[property].x + dxMax;
        labelMinY = item[property].y - dyMin;
        labelMaxY = item[property].y + dyMax;

        item[property].x = (labelMinX < coordonate.x && coordonate.x < labelMaxX) ? coordonate.x : coordonate.x < labelMinX ? (labelMinX + dxMin) : (labelMaxX - dxMax);
        item[property].y = (labelMinY < coordonate.y && coordonate.y < labelMaxY) ? coordonate.y : coordonate.y < labelMinY ? (labelMinY + dyMin) : (labelMaxY - dyMax);
    }

    getCellLabel(uuid, uuidParentCell) {
        let cellLabel = null;
        for (let i = 0; i < this.labelsList.length; i++) {
            if (this.labelsList[i].uuidCell === uuid) {
                if (this.labelsList[i].firstLoaded) {
                    this.labelsList[i].uuidCell = uuidParentCell;
                    this.labelsList[i].firstLoaded = false;
                }

                cellLabel = this.labelsList[i];
                break;
            }
        }
        return cellLabel;
    }

    getConnectorLabel(uuid, connectorDetails) {
        let conLabel = null;
        for (let i = 0; i < this.connectorsList.length; i++) {
            if (this.connectorsList[i].uuid === uuid) {
                if (this.connectorsList[i].label && this.connectorsList[i].label.firstLoaded) {
                    this.connectorsList[i].label.firstLoaded = false;
                    this.connectorsList[i].instance = connectorDetails;
                    this.connectorsList[i].lineMidPoint = connectorDetails.midPoint;
                }
                conLabel = this.connectorsList[i];
                break;
            }
        }
        return conLabel;
    }

    // update plugin label
    setNewLabel(uuid, newLabel) {
        if (newLabel.trim()) {
            for (let i = 0; i < this.labelsList.length; i++) {
                if (this.labelsList[i].uuidCell === uuid) {
                    if (this.labelsList[i].label !== newLabel) {
                        this.eventEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.PLUGIN_LABEL_UPDATED,
                            {
                                LABEL_UUID: this.labelsList[i].uuid, LABEL_VALUE: newLabel, PLUGIN_UUID: this.labelsList[i].pluginUUID, PLUGIN_ID: this.labelsList[i].pluginID
                            }, true);
                    }
                    this.labelsList[i].label = newLabel;
                    // if (this.labelsList[i].label !== newLabel) {
                    this.eventEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.PLUGIN_LABEL_UPDATED,
                        {
                            LABEL_UUID: this.labelsList[i].uuid, LABEL_VALUE: this.labelsList[i].label, PLUGIN_UUID: this.labelsList[i].pluginUUID, PLUGIN_ID: this.labelsList[i].pluginID
                        }, false);
                    // }
                    break;
                }
            }
        }
    }

    // ADD / UPDATE Label Connector

    addConnectorLabel(newLabel, e, elem, grid) {
        const gridSizeUtils = new GridSizedViewUtils();
        if (newLabel && e.target.value.trim()) {
            const connNewLabel = {
                uuid: elem.instance.uuid,
                instance: elem.instance,
                lineMidPoint: elem.instance.midPoint,
                label: {
                    uuid: new DiagramUtils().generateUUID(),
                    value: e.target.value,
                    x: elem.instance.midPoint.x + this.labelProperties.paddingLabelX,
                    y: elem.instance.midPoint.y
                        - (parseInt(this.labelProperties.fontLabel) + this.labelProperties.paddingLabelY + elem.instance.midPointRadius + this.labelProperties.paddingLabelTopBottom)
                }
            };
            this.connectorsList.push(connNewLabel);
            this.eventEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.CONNECTOR_LABEL_UPDATED,
                { LABEL_UUID: connNewLabel.label.uuid, LABEL_VALUE: connNewLabel.label.value, CONNECTOR_UUID: connNewLabel.uuid });
            elem.instance.update(null, { connectorErrorState: false });
            elem.instance.draw();
        } else {
            for (let i = 0; i < this.connectorsList.length; i++) {
                if (elem.uuid === this.connectorsList[i].uuid) {
                    this.connectorsList[i].label.value = e.target.value.trim() ? e.target.value : this.connectorsList[i].label.value;

                    this.eventEmitter.emitEvent(DIAGRAM_EMIT_EVENTS.CONNECTOR_LABEL_UPDATED,
                        { LABEL_UUID: this.connectorsList[i].label.uuid, LABEL_VALUE: this.connectorsList[i].label.value, CONNECTOR_UUID: this.connectorsList[i].uuid });

                    break;
                }
            }
            const newCellPos = gridSizeUtils.getPermanentGridCellPos(elem.label, grid);
            const cell = this.cellRetrieval.getCell(newCellPos, grid);
            if (cell) cell.draw();
        }
    }

    updateLabelPosition(initialCell, newCell, grid) {
        for (let i = 0; i < this.labelsList.length; i++) {
            if (this.labelsList[i].uuidCell === initialCell.uuid) {
                this.updateLabelCoordinates(initialCell, newCell, this.labelsList[i], grid);
            }
        }
    }

    updateConnectorLabelPosition(connectingLineHandler, grid, cellIndepPluginHandler, ctx) {
        const scope = this.connectorsList;
        connectingLineHandler.connectors.forEach(element => {
            for (let i = 0; i < scope.length; i++) {
                if (element.instance.uuid === scope[i].uuid) {
                    this.clearRectBeforeCreateLabel(ctx, scope[i].label.value, scope[i].label.x, scope[i].label.y, "LABELCONN", null, "noLabel", grid);
                    let dx; let
                        dy;
                    const currentLabelSize = this.getLabelWidth(ctx, scope[i].label.value);
                    currentLabelSize.width = Math.floor(currentLabelSize.labelWidth.width);
                    currentLabelSize.height = parseInt(this.labelProperties.fontLabel);
                    const { label } = scope[i];
                    const coveredCells = cellIndepPluginHandler.getCoveredCells({ x: label.x, y: label.y }, currentLabelSize, grid, false);

                    dx = element.instance.midPoint.x - scope[i].lineMidPoint.x;
                    dy = element.instance.midPoint.y - scope[i].lineMidPoint.y;
                    scope[i].label.x += dx;
                    scope[i].label.y += dy;
                    scope[i].lineMidPoint.x = element.instance.midPoint.x;
                    scope[i].lineMidPoint.y = element.instance.midPoint.y;
                    element.instance.draw();
                    coveredCells.forEach(cell => {
                        if (cell) cell.draw();
                    });
                    break;
                }
            }
        });
    }

    updateLabelCoordinates(initialCell, newCell, elem, grid) {
        let newX; let newY; const xCood = elem.labelPosition.x; const
            yCood = elem.labelPosition.y;
        setTimeout(() => {
            this.clearRectBeforeCreateLabel(initialCell.ctx, elem.label, xCood, yCood, null, null, "noLabel", grid);
        }, 0);

        if (initialCell.layout.x < newCell.layout.x) {
            newX = { x: newCell.layout.x - initialCell.layout.x, type: true };
        } else if (initialCell.layout.x > newCell.layout.x) {
            newX = { x: initialCell.layout.x - newCell.layout.x, type: false };
        }

        if (initialCell.layout.y < newCell.layout.y) {
            newY = { y: newCell.layout.y - initialCell.layout.y, type: true };
        } else if (initialCell.layout.y > newCell.layout.y) {
            newY = { y: initialCell.layout.y - newCell.layout.y, type: false };
        }

        if (newX) {
            if (newX.type) {
                elem.labelPosition.x = elem.labelPosition.x + newX.x;
                elem.labelDragPoint.x = elem.labelDragPoint.x + newX.x;
            } else {
                elem.labelPosition.x = elem.labelPosition.x - newX.x;
                elem.labelDragPoint.x = elem.labelDragPoint.x - newX.x;
            }
        }

        if (newY) {
            if (newY.type) {
                elem.labelPosition.y = elem.labelPosition.y + newY.y;
                elem.labelDragPoint.y = elem.labelDragPoint.y + newY.y;
            } else {
                elem.labelPosition.y = elem.labelPosition.y - newY.y;
                elem.labelDragPoint.y = elem.labelDragPoint.y - newY.y;
            }
        }

        elem.cellStartPoint.x = newCell.layout.x;
        elem.cellStartPoint.y = newCell.layout.y;
        elem.uuidCell = newCell.uuid;
    }

    deleteLabel(uuid, grid, ctx) {
        for (let i = 0; i < this.labelsList.length; i++) {
            if (this.labelsList[i].uuidCell === uuid) {
                const labelToRemove = this.labelsList[i];
                this.labelsList.splice(i, 1);
                if (grid && ctx) {
                    this.clearRectBeforeCreateLabel(ctx, labelToRemove.label, labelToRemove.labelPosition.x, labelToRemove.labelPosition.y, null, null, "noLabel", grid);
                }
                break;
            }
        }
    }

    getLabelWidth(ctx, label, connector) {
        const textObject = {}; const
            labelValue = typeof label === "object" ? label.value : label;

        if (labelValue && labelValue.length > 20) {
            const labelArrays = labelValue.split(" "); let newLabelFirstLine = ""; let
                newSecondLine;
            for (let i = 0; i < labelArrays.length; i++) {
                if (newLabelFirstLine.length + labelArrays[i].length < 20) {
                    newLabelFirstLine += (newLabelFirstLine.length ? " " : "") + labelArrays[i];
                } else {
                    break;
                }
            }

            textObject.firstLine = newLabelFirstLine;

            newSecondLine = labelValue.substring(newLabelFirstLine.length).trim();
            textObject.secondLine = newSecondLine.length > 17 ? `${labelValue.substring(newLabelFirstLine.length, newLabelFirstLine.length + 17)}...` : newSecondLine;

            // }
            // else if (labelValue && labelValue.length > 17) {
            //     if (labelValue.length <= 20 && labelValue.length > 17) {
            //         textObject["firstLine"] = labelValue;
            //     } else {
            //         let stripHere = 17;
            //         textObject["firstLine"] = labelValue.substring(0, stripHere) + "...";
            //     }
        } else {
            textObject.firstLine = labelValue || "";
        }
        if (textObject.secondLine) {
            const widthFirstLine = ctx.measureText(textObject.firstLine);
            const widthSecondLine = ctx.measureText(textObject.secondLine);
            textObject.labelWidth = widthFirstLine.width > widthSecondLine.width ? widthFirstLine : widthSecondLine;
        } else {
            textObject.labelWidth = ctx.measureText(textObject.firstLine);
        }

        return textObject;
    }

    deleteConnectorsLine(uuid) {
        for (let i = 0; i < this.connectorsList.length; i++) {
            if (this.connectorsList[i].uuid === uuid) {
                this.connectorsList.splice(i, 1);
                break;
            }
        }
    }

    // update plugin label from outside event
    updatePluginLabelValue(uuid, newValue, noEvent) {
        for (let i = 0; i < this.labelsList.length; i++) {
            if (this.labelsList[i].pluginUUID === uuid) {
                const newLabel = this.labelsList[i].label !== newValue;
                const type = DIAGRAM_EMIT_EVENTS.PLUGIN_LABEL_UPDATED;
                const payload = {
                    LABEL_UUID: this.labelsList[i].uuid, LABEL_VALUE: newValue, PLUGIN_UUID: this.labelsList[i].pluginUUID, PLUGIN_ID: this.labelsList[i].pluginID
                };
                this.labelsList[i].label = newValue;
                if (newLabel && !noEvent) {
                    this.eventEmitter.emitEvent(type, payload, false);
                }
                break;
            }
        }
        this.camera.draw();
    }

    // update connector label from outside event
    updateConnectorLabel(uuid, newValue, grid) {
        const gridSizeUtils = new GridSizedViewUtils();
        if (newValue && newValue.trim()) {
            let connectorWithoutLabel = true;
            for (let i = 0; i < this.connectorsList.length; i++) {
                if (this.connectorsList[i].uuid === uuid) {
                    this.connectorsList[i].label.value = newValue;
                    const newCellPos = gridSizeUtils.getPermanentGridCellPos(this.connectorsList[i].label, grid);
                    const cell = this.cellRetrieval.getCell(newCellPos, grid);
                    if (cell) {
                        const connectorInstance = this.connectingLineHandler.connectors.get(uuid);
                        if (connectorInstance && connectorInstance.instance) {
                            connectorInstance.instance.update(null, { connectorErrorState: false });
                            connectorInstance.instance.draw();
                        }
                        cell.draw();
                    }
                    connectorWithoutLabel = false;
                    break;
                }
            }

            if (connectorWithoutLabel) {
                this.connectingLineHandler.connectors.forEach(element => {
                    if (element.instance.uuid === uuid) {
                        const connNewLabel = {
                            uuid: element.instance.uuid,
                            instance: element.instance,
                            lineMidPoint: element.instance.midPoint,
                            label: {
                                uuid: new DiagramUtils().generateUUID(),
                                value: newValue,
                                x: element.instance.midPoint.x,
                                y: element.instance.midPoint.y
                                    - (parseInt(this.labelProperties.fontLabel) + this.labelProperties.paddingLabelY + element.instance.midPointRadius)
                            }
                        };
                        this.connectorsList.push(connNewLabel);
                        element.instance.draw();
                    }
                });
            }
        }
    }

    returnPluginLabelOnSave(uuid) {
        const label = {};
        for (let i = 0; i < this.labelsList.length; i++) {
            if (this.labelsList[i].pluginUUID === uuid) {
                label.value = this.labelsList[i].label;
                label.uuid = this.labelsList[i].uuid;
                label.x = this.labelsList[i].labelPosition.x;
                label.y = this.labelsList[i].labelPosition.y;
                label.labelOf = this.labelsList[i].pluginUUID;
                label.pluginUUID = this.labelsList[i].pluginUUID;
                label.pluginID = this.labelsList[i].pluginID;
                if (this.labelsList[i].hasOwnProperty("additionalOptions")) {
                    label.additionalOptions = this.labelsList[i].additionalOptions;
                }

                break;
            }
        }
        return label;
    }

    returnConnectorLabelOnSave(uuid) {
        const label = {};
        for (let i = 0; i < this.connectorsList.length; i++) {
            if (this.connectorsList[i].uuid === uuid) {
                label.value = this.connectorsList[i].label.value;
                label.uuid = this.connectorsList[i].label.uuid;
                label.x = this.connectorsList[i].label.x;
                label.y = this.connectorsList[i].label.y;
                label.labelOf = this.connectorsList[i].uuid;
                break;
            }
        }
        return label;
    }

    addLoadedNewLabels(data, label, type, reset) {
        if (type === "pluginLabel") {
            const newLabel = {
                firstLoaded: true,
                label: label.value,
                labelPosition: { x: label.x, y: label.y },
                labelDragPoint: { x: "", y: "" },
                cellStartPoint: { x: data.x + 1, y: data.y + 1 },
                uuidCell: data.uuid,
                uuid: label.uuid,
                labelMoved: false,
                pluginUUID: label.pluginUUID,
                pluginID: label.pluginID
            };
            if (label.hasOwnProperty("additionalOptions")) {
                newLabel.additionalOptions = label.additionalOptions;
            }
            this.labelsList.push(newLabel);
        } else if (label && label.value) {
            const newLabel = {
                label: {
                    firstLoaded: true,
                    uuid: new DiagramUtils().generateUUID(),
                    value: label.value,
                    x: label.x,
                    y: label.y
                },
                uuid: label.labelOf

            };
            this.connectorsList.push(newLabel);
        }
    }

    checkIfIsNewLabel(uuid) {
        let isNew = true;
        for (let i = 0; i < this.connectorsList.length; i++) {
            if (this.connectorsList[i].uuid === uuid) {
                isNew = false;
                break;
            }
        }
        return isNew;
    }

    // clear old label before create new label
    clearRectBeforeCreateLabel(ctx, label, x, y, labelConn, customProp, resetLabel, grid) {
        const mesureWidth = this.getLabelWidth(ctx, typeof label === "object" ? label.value : label);

        this.createBackgroundLabelRectangle(x, y, mesureWidth.labelWidth.width, ctx, labelConn, customProp, resetLabel, grid);
    }

    // create label background rectangle
    createBackgroundLabelRectangle(x, y, labelWidth, ctx, labelConn, customProp, resetLabel, grid) {
        this.getSelectedCellInstance();
        const xBackground = x - (labelWidth / 2) - (this.labelProperties.paddingLabelX * 2) - (this.labelProperties.dragPointLabelRadius * 2);
        const yBackground = customProp && customProp === "HAS_SECOND_LINE" ? y - parseInt(this.labelProperties.fontLabel) - (parseInt(this.labelProperties.paddingLabelTopBottom) * 3) : y - parseInt(this.labelProperties.paddingLabelTopBottom);
        const widthBackground = (this.labelProperties.paddingLabelX * 2) + (this.labelProperties.dragPointLabelRadius * 2) + labelWidth + this.labelProperties.paddingLabelX;
        const heightBackground = customProp && customProp === "HAS_SECOND_LINE" ? (parseInt(this.labelProperties.fontLabel) + parseInt(this.labelProperties.paddingLabelTopBottom) * 2) * 2 : parseInt(this.labelProperties.fontLabel) + parseInt(this.labelProperties.paddingLabelTopBottom) * 2;

        const styleBackground = {
            lineWidth: this.labelProperties.lineWidthBackground,
            strokeStyle: labelConn ? this.labelProperties.backgroundStrokeConnector : this.getLabelInstance(x, y) ? this.labelProperties.dragPointSelectedStrokeTask : this.labelProperties.backgroundStrokeTask,
            fillStyle: labelConn ? this.labelProperties.backgroundFillConnector : this.labelProperties.backgroundFillTask
        };
        if (resetLabel) {
            this.redrawLabelCells(xBackground, yBackground, widthBackground, heightBackground, grid);
        } else {
            roundRect(xBackground, yBackground, widthBackground, heightBackground, this.labelProperties.backgroundBorderRadius, styleBackground, ctx);
        }
    }

    // redraw label covered cells
    redrawLabelCells(x, y, width, height, grid) {
        const gridSizeUtils = new GridSizedViewUtils();
        const newCellStartLabel = gridSizeUtils.getPermanentGridCellPos({ x, y }, grid);
        const newCellEndLabel = gridSizeUtils.getPermanentGridCellPos({ x: (x + width), y: (y + height) }, grid);
        const sameCell = newCellStartLabel && newCellEndLabel && newCellStartLabel.row === newCellEndLabel.row && newCellStartLabel.col === newCellEndLabel.col;
        if (sameCell) {
            this.redrawCurrentCell(newCellStartLabel, grid);
        } else {
            if (newCellStartLabel) this.redrawCurrentCell(newCellStartLabel, grid);
            if (newCellEndLabel) this.redrawCurrentCell(newCellEndLabel, grid);
        }
    }

    // redraw each covered cell
    redrawCurrentCell(cell, grid) {
        const currentCell = this.cellRetrieval.getCell(cell, grid);
        currentCell.draw();
    }

    // check to find current selected stage label
    getLabelInstance(x, y) {
        const labelInstance = this.labelsList.filter(stageLabel => (stageLabel.labelPosition.x === x && stageLabel.labelPosition.y === y));
        return labelInstance && labelInstance[0] ? (labelInstance[0].disabled ? false : this.selectedCellPlugin && this.selectedCellPlugin.uuid === labelInstance[0].pluginUUID) : false;
    }

    // get current cell selected instance
    getSelectedCellInstance() {
        const selectedCell = this.cellSelection.cellRetrieval.getCell(this.cellSelection.lastSelectedCell, this.cellSelection.grid);
        this.selectedCellPlugin = this.cellSelection.lastSelectedCell && selectedCell && selectedCell.getContentInstance() ? selectedCell.getContentInstance() : null;
    }

    updateConnLabelPosExpandGrid(element) {
        for (let i = 0; i < this.connectorsList.length; i++) {
            if (this.connectorsList[i].uuid === element.uuid) {
                let dx; let
                    dy;
                dx = element.midPoint.x - this.connectorsList[i].lineMidPoint.x;
                dy = element.midPoint.y - this.connectorsList[i].lineMidPoint.y;
                this.connectorsList[i].label.x += dx;
                this.connectorsList[i].label.y += dy;
                this.connectorsList[i].lineMidPoint.x = element.midPoint.x;
                this.connectorsList[i].lineMidPoint.y = element.midPoint.y;
                break;
            }
        }
    }

    updateStateLabel(state, uuid) {
        if (state && state.hasOwnProperty("disabled")) {
            for (let i = 0; i < this.labelsList.length; i++) {
                if (this.labelsList[i].pluginUUID === uuid) {
                    this.labelsList[i].disabled = state.disabled;
                    break;
                }
            }
        }
    }

    updateStateConnectorLabel(state, checkIfPluginAscOrder, uuid) {
        for (let i = 0; i < this.connectorsList.length; i++) {
            if (this.connectorsList[i].uuid === uuid) {
                this.connectorsList[i].disabled = checkIfPluginAscOrder || state.disabled;
            }
        }
    }
}
